import { render, staticRenderFns } from "./ServicosCadastroForm.vue?vue&type=template&id=49b06c7d&scoped=true&"
import script from "./ServicosCadastroForm.vue?vue&type=script&lang=js&"
export * from "./ServicosCadastroForm.vue?vue&type=script&lang=js&"
import style0 from "./ServicosCadastroForm.vue?vue&type=style&index=0&id=49b06c7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b06c7d",
  null
  
)

export default component.exports